<script>
import { mapGetters } from 'vuex'
import ApexClubPitch from '../components/ApexClubPitch.vue'
import messages from '@/mixins/messages'

export default {
    name: 'ApexClub',
    mixins: [messages],
    components: {
        ApexClubPitch,
    },
    computed: {
        ...mapGetters(['isApexClub']),
        initialSessions() {
            if (this.$route.query.sessions) {
                return parseInt(this.$route.query.sessions)
            }
            
            return undefined
        }
    },
    data() {
        return {
            loading: true,
        }
    },
    methods: {},
    async mounted() {
        if (this.isApexClub || !this.$appConfig('APEX_CLUB_ENABLED', true)) {
            this.$router.push({ name: 'dashboard' })
        }

        this.loading = false
    },
}
</script>

<template>
    <div>
        <header-image :kicker="$appConfig('APEX_CLUB_NAME', 'Apex Club')">
            <h1>Abonnement</h1>
        </header-image>

        <b-container class="mt-5 mb-5" fluid="lg" v-if="!loading">
            <b-row>
                <b-col md="6" offset-md="3">
                    <b-card :header="$appConfig('APEX_CLUB_NAME', 'Apex Club') + ' — Inscription'">
                        <apex-club-pitch :sessions="initialSessions" @success="$router.push({ name: 'dashboard' })" />
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<style lang="scss" scoped>
</style>
